import React, { useEffect, useRef, lazy } from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function Testimonials() {
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    // Track ViewContent cuando el usuario ve los testimonios
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && typeof window !== 'undefined' && (window as any).fbq) {
          ;
          (window as any).fbq('track', 'ViewContent', {
            content_name: 'Testimonials Section',
            content_category: 'Social Proof'
          });
          observer.disconnect(); // Solo trackear una vez
        }
      });
    }, {
      threshold: 0.5
    }) // Cuando 50% de la sección es visible
    ;
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => observer.disconnect();
  }, []);
  const testimonials = [{
    name: 'María González',
    location: 'CDMX',
    rating: 5,
    result: '$847 primera semana',
    text: 'En mi primera semana ya había ganado $847 pesos. La guía es super clara, paso a paso. Ahora gano más de $12,000 al mes.',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop&crop=faces'
  }, {
    name: 'Ana Rodríguez',
    location: 'Guadalajara',
    rating: 5,
    result: '$10,400 primer mes',
    text: 'Lo mejor es que trabajo mientras mis hijos están en la escuela. Ya llevo 3 meses ganando más de $10,000 mensuales.',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=faces'
  }, {
    name: 'Lupita Hernández',
    location: 'Monterrey',
    rating: 5,
    result: 'Primera venta en 4 días',
    text: 'Nunca había vendido en línea y me daba miedo. Hice mi primera venta en 4 días. ¡Totalmente recomendada!',
    image: 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=150&h=150&fit=crop&crop=faces'
  }, {
    name: 'Carmen Silva',
    location: 'Puebla',
    rating: 5,
    result: '$1,200 segunda semana',
    text: 'Siguiendo la guía al pie de la letra, en mi segunda semana ya ganaba $1,200. Ahora es mi ingreso principal.',
    image: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=150&h=150&fit=crop&crop=faces'
  }, {
    name: 'Rosa Martínez',
    location: 'Tijuana',
    rating: 5,
    result: '$8,900 en 30 días',
    text: 'La mejor inversión que he hecho. Por $190 pesos obtuve un sistema que me genera más de $8,000 al mes.',
    image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=faces'
  }, {
    name: 'Patricia López',
    location: 'León',
    rating: 5,
    result: '$650 primera semana',
    text: 'Soy mamá soltera y necesitaba ingresos urgente. En una semana ya había ganado $650. Cada semana gano más.',
    image: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=150&h=150&fit=crop&crop=faces'
  }];
  return <section ref={sectionRef} className="section-spacing bg-gradient-warm" data-id="element-511">
      <div className="container-premium" data-id="element-512">
        <div className="text-center mb-10" data-id="element-513">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black text-deep-cocoa mb-3" data-id="element-514">
            Resultados reales de mujeres como tú
          </h2>
          <p className="text-base text-deep-cocoa/70" data-id="element-515">
            2,347 mujeres ya están generando ingresos
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-516">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-xl p-5 shadow-soft hover:shadow-medium transition-shadow animate-fade-in-up" style={{
          animationDelay: `${index * 100}ms`
        }} data-id="element-517">
              {/* Quote Icon */}
              <QuoteIcon className="w-7 h-7 text-champagne-gold/30 mb-3" data-id="element-518" />

              {/* Rating */}
              <div className="flex gap-1 mb-3" data-id="element-519">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-cta-secondary text-cta-secondary" data-id="element-520" />)}
              </div>

              {/* Result Badge */}
              <div className="inline-block bg-accent-success/10 px-2.5 py-1 rounded-full mb-3" data-id="element-521">
                <span className="text-xs font-bold text-accent-success" data-id="element-522">
                  ✨ {testimonial.result}
                </span>
              </div>

              {/* Text */}
              <p className="text-deep-cocoa/80 mb-4 leading-relaxed text-sm" data-id="element-523">
                "{testimonial.text}"
              </p>

              {/* Author - IMAGEN OPTIMIZADA */}
              <div className="flex items-center gap-3 pt-3 border-t border-deep-cocoa/10" data-id="element-524">
                <img src={testimonial.image} alt={testimonial.name} width="40" height="40" loading="lazy" decoding="async" className="w-10 h-10 rounded-full object-cover shadow-soft" data-id="element-525" />
                <div data-id="element-526">
                  <div className="font-bold text-deep-cocoa text-sm" data-id="element-527">
                    {testimonial.name}
                  </div>
                  <div className="text-xs text-deep-cocoa/60" data-id="element-528">
                    {testimonial.location}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}